<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="560px"
    append-to-body
    @closed="reset"
  >
    <el-form label-width="120px" v-loading="loading">
      <el-form-item v-if="fileType === 'pd'" label="批单号"
        ><el-input v-model.trim="endorsementNo"
      /></el-form-item>
      <el-form-item :label="title"
        ><employer-file-upload v-model="files" :multiple="fileType !== 'pd'"
      /></el-form-item>
    </el-form>
    <span slot="footer"
      ><el-button @click="dialogVisible = false">取消</el-button
      ><el-button type="primary" :loading="submitting" @click="submit"
        >保存</el-button
      ></span
    >
  </el-dialog>
</template>
<script>
import {
  getEmployerHistoryInfo,
  uploadEmployerCorrectFile,
  uploadEmployerEndorsement,
  uploadEmployerPayVoucher
} from "@/api/employer-insurance";
import EmployerFileUpload from "./EmployerFileUpload.vue";
const parse = value => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  try {
    return parse(JSON.parse(value));
  } catch (e) {
    return [String(value)];
  }
};
export default {
  name: "HistoryFileDialog",
  components: { EmployerFileUpload },
  props: {
    visible: { type: Boolean, default: false },
    row: { type: Object, default: () => ({}) },
    fileType: { type: String, default: "pg" }
  },
  data() {
    return { loading: false, submitting: false, files: [], endorsementNo: "" };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit("update:visible", v);
      }
    },
    title() {
      return this.fileType === "pd"
        ? "上传批单"
        : this.fileType === "pz"
        ? "上传支付凭证"
        : "上传批改申请";
    }
  },
  watch: {
    visible(v) {
      if (v) this.loadInfo();
    }
  },
  methods: {
    async loadInfo() {
      this.loading = true;
      try {
        const res = await getEmployerHistoryInfo({ order_id: this.row.id });
        const data = (res && res.order) || {};
        this.files =
          this.fileType === "pg"
            ? parse(data.correct_url)
            : this.fileType === "pz"
            ? parse(data.pay_voucher_url)
            : parse(data.endorsement_url);
        this.endorsementNo =
          data.endorsement_no || this.row.endorsement_no || "";
      } finally {
        this.loading = false;
      }
    },
    async submit() {
      if (!this.files.length) {
        this.$message.warning(`请${this.title}`);
        return;
      }
      this.submitting = true;
      try {
        const base = {
          order_id: Number(this.row.order_id),
          group_no: this.row.group_no
        };
        let res;
        if (this.fileType === "pg")
          res = await uploadEmployerCorrectFile({
            ...base,
            correct_url: this.files
          });
        else if (this.fileType === "pz")
          res = await uploadEmployerPayVoucher({
            ...base,
            pay_voucher_url: this.files
          });
        else
          res = await uploadEmployerEndorsement({
            ...base,
            endorsement_no: this.endorsementNo,
            endorsement_url: this.files[0]
          });
        if (!res) return;
        this.$message.success("保存成功");
        this.dialogVisible = false;
        this.$emit("success");
      } finally {
        this.submitting = false;
      }
    },
    reset() {
      this.files = [];
      this.endorsementNo = "";
    }
  }
};
</script>
